import { call, put, takeLatest, takeEvery } from 'redux-saga/effects';
import { commentService } from './comment.service';
import {
  GET_COMMENTS, GET_COMMENTS_SUCCESS,
  CREATE_COMMENT, CREATE_COMMENT_SUCCESS,
  UPDATE_COMMENT, UPDATE_COMMENT_SUCCESS,
  DELETE_COMMENT, DELETE_COMMENT_SUCCESS,
  GET_UNRESOLVED_COUNTS, GET_UNRESOLVED_COUNTS_SUCCESS,
} from './comment.types';
import { httpRequestsOnLoadActions } from '../http_requests_on_load';
import { httpRequestsOnErrorsActions } from '../http_requests_on_errors';
import { httpRequestsOnSuccessActions } from '../http_requests_on_success';

function* getCommentsSaga({ type, payload }) {
  yield put(httpRequestsOnLoadActions.appendLoading(type));
  yield put(httpRequestsOnErrorsActions.removeError(type));
  try {
    const res = yield call(commentService.getComments, payload);
    yield put({ type: GET_COMMENTS_SUCCESS, payload: res.data });
    yield put(httpRequestsOnLoadActions.removeLoading(type));
  } catch (err) {
    yield put(httpRequestsOnLoadActions.removeLoading(type));
    yield put(httpRequestsOnErrorsActions.appendError(type, err?.data?.message));
  }
}

function* createCommentSaga({ type, payload }) {
  yield put(httpRequestsOnLoadActions.appendLoading(type));
  yield put(httpRequestsOnErrorsActions.removeError(type));
  try {
    const res = yield call(commentService.createComment, payload);
    yield put({ type: CREATE_COMMENT_SUCCESS, payload: res.data });
    yield put(httpRequestsOnLoadActions.removeLoading(type));
    yield put(httpRequestsOnSuccessActions.appendSuccess(type));
  } catch (err) {
    yield put(httpRequestsOnLoadActions.removeLoading(type));
    yield put(httpRequestsOnErrorsActions.appendError(type, err?.data?.message));
  }
}

function* updateCommentSaga({ type, payload }) {
  yield put(httpRequestsOnLoadActions.appendLoading(type));
  yield put(httpRequestsOnErrorsActions.removeError(type));
  try {
    const res = yield call(commentService.updateComment, payload.id, payload.data);
    yield put({ type: UPDATE_COMMENT_SUCCESS, payload: res.data });
    yield put(httpRequestsOnLoadActions.removeLoading(type));
    yield put(httpRequestsOnSuccessActions.appendSuccess(type));
  } catch (err) {
    yield put(httpRequestsOnLoadActions.removeLoading(type));
    yield put(httpRequestsOnErrorsActions.appendError(type, err?.data?.message));
  }
}

function* deleteCommentSaga({ type, payload }) {
  yield put(httpRequestsOnLoadActions.appendLoading(type));
  yield put(httpRequestsOnErrorsActions.removeError(type));
  try {
    yield call(commentService.deleteComment, payload);
    yield put({ type: DELETE_COMMENT_SUCCESS, payload });
    yield put(httpRequestsOnLoadActions.removeLoading(type));
    yield put(httpRequestsOnSuccessActions.appendSuccess(type));
  } catch (err) {
    yield put(httpRequestsOnLoadActions.removeLoading(type));
    yield put(httpRequestsOnErrorsActions.appendError(type, err?.data?.message));
  }
}

function* getUnresolvedCountsSaga({ type, payload }) {
  yield put(httpRequestsOnLoadActions.appendLoading(type));
  try {
    const res = yield call(commentService.getUnresolvedCounts, payload);
    yield put({ type: GET_UNRESOLVED_COUNTS_SUCCESS, payload: res.data });
    yield put(httpRequestsOnLoadActions.removeLoading(type));
  } catch (err) {
    yield put(httpRequestsOnLoadActions.removeLoading(type));
  }
}

export function* watchComments() {
  yield takeLatest(GET_COMMENTS, getCommentsSaga);
  yield takeEvery(CREATE_COMMENT, createCommentSaga);
  yield takeEvery(UPDATE_COMMENT, updateCommentSaga);
  yield takeLatest(DELETE_COMMENT, deleteCommentSaga);
  yield takeLatest(GET_UNRESOLVED_COUNTS, getUnresolvedCountsSaga);
}
